export {default} from './LanguageModel';
export * from './LanguageModel';



// WEBPACK FOOTER //
// ./src/models/LanguageModel/index.ts